import React from 'react';
import PropTypes from 'prop-types';
import { onKeyDownFunction, onKeyUpFunction } from '@utils/a11y';
import Name from '../Components/ProductName';
import Price from '../Components/ProductPrice';
import Header from '../Components/Header';
import Image from '../Components/Image';
import Container from '../Components/Container';
import InfoContainer from '../Components/InfoContainer';
import ActionsContainer from '../Components/ActionsContainer';
import Tags from '../Components/Tags';
import PricePerUnit from '../Components/PricePerUnit';

function Food({
  name,
  descriptionCollapsible,
  price,
  image,
  onClick,
  tags,
  isBoldName,
  measurementUnit,
  onAddFavorite,
  ...props
}) {
  const {
    pricePerMeasurementUnit,
    measurementUnitId,
    measurementItems,
  } = measurementUnit;

  return (
    <Container
      role="article"
      aria-label={name}
      aria-description={descriptionCollapsible.props.description}
      tabIndex={0}
      onClick={onClick}
      onKeyUp={e => onKeyUpFunction(e, () => onClick({ e }))}
      onKeyDown={e => onKeyDownFunction(e, () => onClick({ e }))}
      {...props}
    >
      <InfoContainer>
        <div>
          <Tags>{tags}</Tags>
          <Header>
            <Name bold={isBoldName} image={image}>
              {name}
            </Name>
            {onAddFavorite}
          </Header>
          {descriptionCollapsible}
        </div>
        <Price>{price}</Price>
        <PricePerUnit
          pricePerMeasurement={pricePerMeasurementUnit}
          measurementItems={measurementItems}
          measurementUnitId={measurementUnitId}
        />
      </InfoContainer>
      <ActionsContainer>
        {image && <Image ariaHidden name={name} image={image} toRight />}
      </ActionsContainer>
    </Container>
  );
}

Food.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func.isRequired,
  isBoldName: PropTypes.bool,
  tags: PropTypes.node,
  measurementUnit: PropTypes.object,
  onAddFavorite: PropTypes.node,
  descriptionCollapsible: PropTypes.node,
};

Food.defaultProps = {
  isBoldName: false,
  onAddFavorite: null,
};

export default Food;
